import { getMoneyValue } from '@/framework/directive/index.js'
import SelectOption from '@/store/dict/selectOptionDict'
import { CATEGORY_CODE_MAP } from '@/store/dict/rentPlanDict.js'

export default function () {
  const schemeRentInfo_group_formConfig = [
    {
      el: 'select',
      itemConfig: {
        label: '类别',
        prop: 'rentCategory',
      },
      elConfig: {
        clearable: false,
        events: {
          change: (val) => {
            if (val !== CATEGORY_CODE_MAP.SI_JI_HE_ZUO_MO_SHI) {
              this.queryFeeList(this.addRequiredFee)
            }
            this.updateData()
          },
        },
        options: { // 下拉数据
          label: 'name',
          value: 'code',
          list: this.categoryData,
        },
      },
    },
    {
      el: 'select',
      itemConfig: {
        label: '预计租赁周期',
        prop: 'rentPeriod',
      },
      render: (createElement) => {
        if (this.rentPeriodType === 'select') {
          return createElement('el-form-item', {
            props: {
              prop: 'rentPeriod',
              label: '预计租赁周期:',
              rules: [{ required: true, message: '租赁周期不能为空', trigger: 'change' }],
            },
          }, [
            createElement('el-select', {
              props: {
                value: this.schemeRentInfo_model.rentPeriod,
                placeholder: '请选择',
                clearable: true,
              },
              on: {
                input: (value) => {
                  this.schemeRentInfo_model.rentPeriod = value
                  if (this.schemeRentInfo_model.rentCategory
                    !== CATEGORY_CODE_MAP.SI_JI_HE_ZUO_MO_SHI) {
                    this.queryFeeList(this.addRequiredFee)
                  } else {
                    this.$emit('rentPeriodChange')
                    this.updateData()
                  }
                },
              },
            }, Object.keys(SelectOption.leasingSchemeByStages).map((key, index) => {
              const value = SelectOption.leasingSchemeByStages[key]
              return createElement('el-option', {
                props: {
                  label: value,
                  value: key,
                },
                key: key + index,
              })
            })),
            createElement('el-button', {
              props: {
                type: 'text',
              },
              attrs: {
                style: 'margin-left: 5px',
              },
              on: {
                click: () => {
                  this.changeGroupRentPeriod('input')
                },
              },
            }, [
              createElement('i', {
                class: 'el-icon-edit',
              }),
              '自定义选月',
            ]),
          ])
        } else {
          return createElement('el-form-item', {
            props: {
              prop: 'rentPeriod',
              label: '预计租赁周期:',
              rules: [{ required: true, message: '租赁周期不能为空', trigger: 'blur' }],
            },
          }, [
            createElement('el-input', {
              style: 'width:188.5px',
              props: {
                value: this.schemeRentInfo_model.rentPeriod,
              },
              on: {
                input: (value) => {
                  const months = getMoneyValue(value) > 60 ? 60 : getMoneyValue(value)
                  this.schemeRentInfo_model.rentPeriod = months
                  if (this.schemeRentInfo_model.rentCategory
                    !== CATEGORY_CODE_MAP.SI_JI_HE_ZUO_MO_SHI) {
                    this.queryFeeList(this.addRequiredFee)
                  } else {
                    this.updateData()
                  }
                },
              },
            }, [
              createElement('template', { slot: 'append' }, '个月'),
            ]),
            createElement('el-button', {
              props: {
                type: 'text',
              },
              attrs: {
                style: 'margin-left: 5px;',
              },
              on: {
                click: () => {
                  this.changeGroupRentPeriod('select')
                },
              },
            }, [
              createElement('i', {
                class: 'el-icon-edit',
              }),
              '下拉选月',
            ]),
          ])
        }
      },
    },
    {
      el: 'input',
      itemConfig: {
        label: '赠送天数',
        prop: 'presentDays',
      },
      render: () => {
        const h = this.$createElement
        return h('el-form-item', {
          props: {
            prop: 'presentDays',
            label: '赠送天数:',
          },
        }, [
          h('el-input', {
            attrs: {
              placeholder: '请输入0~365之间的数字',
              maxlength: 3,
              style: 'width: 185px;', // 添加宽度属性
            },
            props: {
              value: this.schemeRentInfo_model.presentDays,
            },
            on: {
              input: (value) => {
                const days = getMoneyValue(value) > 365 ? 365 : getMoneyValue(value)
                this.schemeRentInfo_model.presentDays = days
              },
            },
          }, [
            h('template', { slot: 'append' }, '天'),
          ]),
        ])
      },
    },
  ]

  const schemeRentInfo_formConfig = [
    {
      el: 'select',
      itemConfig: {
        label: '类别',
        prop: 'rentCategory',
      },
      elConfig: {
        clearable: false,
        events: {
          change: (val) => {
            if (val !== CATEGORY_CODE_MAP.SI_JI_HE_ZUO_MO_SHI) {
              this.queryFeeList(this.addRequiredFee)
            }

            this.updateData()
          },
        },
        options: { // 下拉数据
          label: 'name',
          value: 'code',
          list: this.categoryData,
        },
      },
    },
    {
      el: 'select',
      itemConfig: {
        label: '预计租赁周期',
        prop: 'rentPeriod',
      },
      render: (createElement) => {
        if (this.schemeRentInfo_model.rentPeriodType === 3) {
          return createElement('el-form-item', {
            props: {
              prop: 'rentPeriod',
              label: '预计租赁周期:',
              rules: [{ required: true, validator: validateNumber, trigger: 'change' }],
            },
          }, [
            createElement('el-input', {
              style: 'width:188.5px;',
              props: {
                value: this.schemeRentInfo_model.rentPeriod,
              },
              attrs: {
                placeholder: '请输入月数',
              },
              on: {
                input: (value) => {
                  if (value.trim() !== '') {
                    const months = getMoneyValue(value) > 60 ? 60 : getMoneyValue(value)
                    this.schemeRentInfo_model.rentPeriod = String(Math.floor(Number(months)))
                    if (this.schemeRentInfo_model.rentCategory
                      !== CATEGORY_CODE_MAP.SI_JI_HE_ZUO_MO_SHI) {
                      this.queryFeeList(this.addRequiredFee)
                    } else {
                      this.updateData()
                    }
                  } else {
                    this.schemeRentInfo_model.rentPeriod = value
                    this.updateData()
                  }
                },
              },
            }, [
              createElement('template', { slot: 'append' }, '个月'),
            ]),
            createElement('el-button', {
              props: {
                type: 'text',
              },
              attrs: {
                style: 'margin-left: 5px',
              },
              on: {
                click: () => {
                  this.changeRentPeriod(1)
                },
              },
            }, [
              createElement('i', {
                class: 'el-icon-edit',
              }),
              '自定义租赁天数',
            ]),
          ])
        } else {
          return createElement('el-form-item', {
            props: {
              prop: 'rentPeriod',
              label: '预计租赁周期:',
              rules: [{ required: true, validator: validateNumber, trigger: 'change' }],
            },
          }, [
            createElement('el-input', {
              style: 'width:188.5px',
              props: {
                value: this.schemeRentInfo_model.rentPeriod,
              },
              attrs: {
                placeholder: '请输入天数',
              },
              on: {
                input: (value) => {
                  if (value.trim() !== '') {
                    const days = getMoneyValue(value) > 365 ? 365 : getMoneyValue(value)
                    this.schemeRentInfo_model.rentPeriod = String(Math.floor(Number(days)))
                    if (this.schemeRentInfo_model.rentCategory
                      !== CATEGORY_CODE_MAP.SI_JI_HE_ZUO_MO_SHI) {
                      this.queryFeeList(this.addRequiredFee)
                    } else {
                      this.updateData()
                    }
                  } else {
                    this.schemeRentInfo_model.rentPeriod = ''
                    this.updateData()
                  }
                },
              },
            }, [
              createElement('template', { slot: 'append' }, '天'),
            ]),
            createElement('el-button', {
              props: {
                type: 'text',
              },
              attrs: {
                style: 'margin-left: 5px;',
              },
              on: {
                click: () => {
                  this.changeRentPeriod(3)
                },
              },
            }, [
              createElement('i', {
                class: 'el-icon-edit',
              }),
              '自定义租赁月数',
            ]),
          ])
        }
      },
    },
    {
      el: 'input',
      itemConfig: {
        label: '赠送天数',
        prop: 'presentDays',
      },
      render: () => {
        const h = this.$createElement
        return h('el-form-item', {
          props: {
            prop: 'presentDays',
            label: '赠送天数:',
          },
        }, [
          h('el-input', {
            attrs: {
              placeholder: '请输入0~365之间的数字',
              maxlength: 3,
              style: 'width: 185px;', // 添加宽度属性
            },
            props: {
              value: this.schemeRentInfo_model.presentDays,
            },
            on: {
              input: (value) => {
                const days = getMoneyValue(value) > 365 ? 365 : getMoneyValue(value)
                this.schemeRentInfo_model.presentDays = days
              },
            },
          }, [
            h('template', { slot: 'append' }, '天'),
          ]),
        ])
      },
    },
  ]
  const schemeRentInfo_model = {
    rentCategory: CATEGORY_CODE_MAP.ZU_CHE, // 类别，默认租车
    rentPeriod: '', // 预计租赁周期
    presentDays: 0, // 赠送天数
    rentPeriodType: 3, // 租赁周期时间单位 1日/2周/3月
    payMode: '', // 收款方式
  }
  const schemeRentInfo_formRule = {
    rentCategory: [
      {
        required: true,
        message: '租赁类型不能为空',
        trigger: 'change',
      },
    ],
    rentPeriod: [ // 此项表单用的是render函数，所以此项配置实际上不生效
      {
        required: true,
        message: '租期不能为空',
        trigger: 'change',
      },
    ],
    payMode: [
      {
        required: true,
        validator: (rule, value, callback) => {
          if (!value) {
            // 动态生成错误文案
            callback(new Error(`${this.payModeLabel}不能为空`))
          } else {
            callback()
          }
        },
        trigger: 'change',
      },
    ],
  }
  const validateNumber = (rules, val, callback) => {
    if (val.trim() === '') {
      return callback(new Error('租赁周期不能为空'))
    }
    if (Number(val) === 0) {
      return callback(new Error('只能输入大于0的整数'))
    }
    return callback()
  }
  return {
    schemeRentInfo_group_formConfig,
    schemeRentInfo_formConfig,
    schemeRentInfo_model,
    schemeRentInfo_formRule,
  }
}
